import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import MyTheme from './MyTheme';
import { createTheme, ThemeProvider } from '@mui/material/styles';

export default function StyledAppBar({ title, logo }) {
  const imgStyle = {
    height: '40px',
    display: '-webkit - box',
    marginLeft: 'auto'
  };

  const applyTheme = createTheme(MyTheme);

  return (
    <ThemeProvider theme={applyTheme}>
      <AppBar position="static" elevation={0}>
        <Toolbar>
          <Typography variant="h6" component="div" textAlign={'left'} sx={{ flexGrow: 1, fontWeight: 'bold' }}>
            {title}
          </Typography>
          <img src={logo} alt="label" style={imgStyle} />
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  );
}
